var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-container"},[_c('back-link',{staticClass:"mb-5"}),(_vm.statementObject)?_c('operations-list',{attrs:{"saveEnable":true,"showRest":true,"model":_vm.statementObject}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }